import React from 'react';
import clsx from 'clsx';
import styles from './closeButton.module.css';
import { CustomCircularProgress } from '@/components/Loading/CustomCircularProgress';

const CloseButton = ({
  text,
  onClick,
  borderColor,
  color,
  loading,
  width,
  className,
  textClassName,
  textStyle,
  buttonStyle,
  disable,
}) => {
  return (
    <button
      type="button"
      className={clsx(styles.container, className)}
      onClick={!disable ? onClick : undefined}
      disabled={!!disable}
      style={{ borderColor: borderColor, width: width, ...buttonStyle }}>
      {loading ? (
        <CustomCircularProgress className="w-4 h-4 border-primary-text" />
      ) : (
        <span
          style={{ color: color, ...textStyle }}
          className={clsx(styles.text, textClassName)}>
          {text}
        </span>
      )}
    </button>
  );
};

export default CloseButton;

